import { theme as fctgTheme } from '@fctg/core-ui-component';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import { App as AntdApp, ConfigProvider } from 'antd';
import type { FC } from 'react';
import {
	BrowserRouter,
	Route,
	Routes,
} from 'react-router';
import TokenBridge from '@/components/TokenBridge';
import { env } from '@constants/env';
import appRoutes from '@constants/routes/index';
import '@styles/reset.scss';
import { generateRouteElements } from './constants/routes/routeElements';

const oktaAuth = new OktaAuth({
	clientId: env.oktaClientId,
	issuer: env.oktaIssuer,
	scopes: env.oktaScopes,
	pkce: true,
	redirectUri: `${window.location.origin}/callback`,
});

const restoreOriginalUri = async (
	_oktaAuth: OktaAuth,
	originalUri?: string
): Promise<void> => {
	location.replace(toRelativeUrl(originalUri ?? '/', window.location.origin));
};

const App: FC = () => (
	<ConfigProvider theme={fctgTheme}>
		<AntdApp component={false}>
			<BrowserRouter>
				<Security
					oktaAuth={oktaAuth}
					restoreOriginalUri={restoreOriginalUri}
				>
					<TokenBridge />
					<Routes>
						{generateRouteElements(appRoutes)}
						<Route
							path="callback"
							Component={LoginCallback}
						/>
					</Routes>
				</Security>
			</BrowserRouter>
		</AntdApp>
	</ConfigProvider>
);

export default App;
